import { CategorySJsEnv } from '../category_s_js_env';

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_CATEGORY = new r3_category();
  R3_COMMON.addPlacementType(`category_page.${pageOption.placementNameCategorySExternalSite}`);
  R3_COMMON.addPlacementType(`category_page.${pageOption.placementNameCategorySNormal}`);
  R3_COMMON.addPlacementType(`category_page.${pageOption.placementNameCategorySLeftSide}`);

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
};

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setAddToCartPageRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_CATEGORY = new r3_category();
  R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameCategorySMyCatalogModal}`);

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
};

export const setRrRequestParamsSp = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_CATEGORY = new r3_category();
  R3_COMMON.addPlacementType(`category_page.${pageOption.placementNameCategorySSp}`);

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
};

export const createRrRequestParam = (model: CategorySJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameCategorySExternalSite: model.rrAreaProfileCategorySExternalSite.placementName,
      placementNameCategorySNormal: model.rrAreaProfileCategorySNormal.placementName,
      placementNameCategorySLeftSide: model.rrAreaProfileCategorySLeftSide.placementName,
      categoryCode: model.categoryCode,
      categoryName: model.categoryName,
      itemIdList: model.itemIdList
    }
  };
};

export const createRrRequestParamSp = (model: CategorySJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParamsSp,
    pageOption: {
      placementNameCategorySSp: model.rrAreaProfileCategorySSp.placementName,
      categoryCode: model.categoryCode,
      categoryName: model.categoryName,
      itemIdList: model.itemIdList
    }
  };
};
